import { RefObject, useEffect, useRef } from "react";

export const useDebouncedScroll = (ref: RefObject<HTMLElement>, deps: any[], delay = 300) => {
  const timeoutRef = useRef<number>();
  useEffect(() => {
    if (!ref.current) return;
    clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(() => {
      ref.current?.scrollIntoView({ behavior: "smooth" });
    }, delay);

    return () => clearTimeout(timeoutRef.current);
  }, deps);
}